module.exports = __webpack_public_path__ + "media/assets/icons/ic-open-in-27252618778e81989af04e3d3af541b7.svg";